// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyEditV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail,
  RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType,
  RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly,
  RentalManagerUserPropertyEditV2WebApiHandler_contactHours,
  RentalManagerUserPropertyEditV2WebApiHandler_contactName,
  RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee,
  RentalManagerUserPropertyEditV2WebApiHandler_email,
  RentalManagerUserPropertyEditV2WebApiHandler_forRentBy,
  RentalManagerUserPropertyEditV2WebApiHandler_fullDescription,
  RentalManagerUserPropertyEditV2WebApiHandler_hidePhone,
  RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress,
  RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted,
  RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive,
  RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted,
  RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired,
  RentalManagerUserPropertyEditV2WebApiHandler_laundry,
  RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration,
  RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms,
  RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress,
  RentalManagerUserPropertyEditV2WebApiHandler_name,
  RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription,
  RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription,
  RentalManagerUserPropertyEditV2WebApiHandler_phone,
  RentalManagerUserPropertyEditV2WebApiHandler_propertyType,
  RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit,
  RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly,
  RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding,
  RentalManagerUserPropertyEditV2WebApiHandler_videoUrl,
  RentalManagerUserPropertyEditV2WebApiHandler_webSite,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  RentalManagerModularListingProgressV2WebDto,
  UpdateIsApplicationsAcceptedV2RequestDto,
  UserPropertyEditAdditionalEmailV2RequestDto,
  UserPropertyEditAgentLicenseTypeV2RequestDto,
  UserPropertyEditClearPropertyOnlyV2RequestDto,
  UserPropertyEditContactHoursResponseV2WebDto,
  UserPropertyEditContactHoursV2RequestDto,
  UserPropertyEditContactNameV2RequestDto,
  UserPropertyEditDisplayTotalMonthlyPriceWithFeeV2RequestDto,
  UserPropertyEditEmailResponseV2WebDto,
  UserPropertyEditEmailV2RequestDto,
  UserPropertyEditForRentByV2RequestDto,
  UserPropertyEditFullDescriptionV2RequestDto,
  UserPropertyEditHidePhoneV2RequestDto,
  UserPropertyEditHideStreetAddressV2RequestDto,
  UserPropertyEditIsBrokerExclusiveV2RequestDto,
  UserPropertyEditIsIncomeRestrictedV2RequestDto,
  UserPropertyEditIsRentersInsuranceRequiredV2RequestDto,
  UserPropertyEditLaundryV2RequestDto,
  UserPropertyEditLeaseDurationV2RequestDto,
  UserPropertyEditLeaseTermsV2RequestDto,
  UserPropertyEditModularListingProgressV2RequestDto,
  UserPropertyEditNameV2RequestDto,
  UserPropertyEditParkingDescriptionV2RequestDto,
  UserPropertyEditPetPolicyDescriptionV2RequestDto,
  UserPropertyEditPhoneResponseV2WebDto,
  UserPropertyEditPhoneV2RequestDto,
  UserPropertyEditPropertyTypeV2RequestDto,
  UserPropertyEditSecurityDepositResponseV2WebDto,
  UserPropertyEditSecurityDepositV2RequestDto,
  UserPropertyEditSetAsPropertyOnlyV2RequestDto,
  UserPropertyEditUnitsInBuildingV2RequestDto,
  UserPropertyEditVideoUrlV2RequestDto,
  UserPropertyEditWebSiteV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Args {
  postData: UserPropertyEditAdditionalEmailV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_additionalEmail = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_additionalEmail(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Args {
  postData: UserPropertyEditAgentLicenseTypeV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_agentLicenseType(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Args {
  postData: UserPropertyEditClearPropertyOnlyV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_clearPropertyOnly(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Args {
  postData: UserPropertyEditContactHoursV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Options = UseMutationOptions<
  UserPropertyEditContactHoursResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_contactHours = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_contactHours_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_contactHours(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_contactName_Args {
  postData: UserPropertyEditContactNameV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_contactName_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_contactName_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_contactName = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_contactName_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_contactName_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_contactName(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Args {
  postData: UserPropertyEditDisplayTotalMonthlyPriceWithFeeV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_displayTotalMonthlyPriceWithFee(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_email_Args {
  postData: UserPropertyEditEmailV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_email_Options = UseMutationOptions<
  UserPropertyEditEmailResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_email_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_email = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_email_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_email_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_email(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Args {
  postData: UserPropertyEditForRentByV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_forRentBy = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_forRentBy_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_forRentBy(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Args {
  postData: UserPropertyEditFullDescriptionV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_fullDescription = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_fullDescription_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_fullDescription(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Args {
  postData: UserPropertyEditHidePhoneV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_hidePhone = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_hidePhone_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_hidePhone(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Args {
  postData: UserPropertyEditHideStreetAddressV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_hideStreetAddress(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Args {
  postData: UpdateIsApplicationsAcceptedV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_isApplicationsAccepted(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Args {
  postData: UserPropertyEditIsBrokerExclusiveV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_isBrokerExclusive(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Args {
  postData: UserPropertyEditIsIncomeRestrictedV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_isIncomeRestricted(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Args {
  postData: UserPropertyEditIsRentersInsuranceRequiredV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_isRentersInsuranceRequired(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_laundry_Args {
  postData: UserPropertyEditLaundryV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_laundry_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_laundry_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_laundry = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_laundry_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_laundry_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_laundry(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Args {
  postData: UserPropertyEditLeaseDurationV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_leaseDuration = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_leaseDuration(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Args {
  postData: UserPropertyEditLeaseTermsV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_leaseTerms = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_leaseTerms(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Args {
  postData: UserPropertyEditModularListingProgressV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Options = UseMutationOptions<
  RentalManagerModularListingProgressV2WebDto,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_modularListingProgress(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_name_Args {
  postData: UserPropertyEditNameV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_name_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_name_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_name = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_name_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_name_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_name(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Args {
  postData: UserPropertyEditParkingDescriptionV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_parkingDescription = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_parkingDescription(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Args {
  postData: UserPropertyEditPetPolicyDescriptionV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_petPolicyDescription(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_phone_Args {
  postData: UserPropertyEditPhoneV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_phone_Options = UseMutationOptions<
  UserPropertyEditPhoneResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_phone_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_phone = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_phone_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_phone_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_phone(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Args {
  postData: UserPropertyEditPropertyTypeV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_propertyType = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_propertyType_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_propertyType(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Args {
  postData: UserPropertyEditSecurityDepositV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Options = UseMutationOptions<
  UserPropertyEditSecurityDepositResponseV2WebDto,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_securityDeposit = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_securityDeposit(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Args {
  postData: UserPropertyEditSetAsPropertyOnlyV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_setAsPropertyOnly(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Args {
  postData: UserPropertyEditUnitsInBuildingV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_unitsInBuilding(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Args {
  postData: UserPropertyEditVideoUrlV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_videoUrl = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_videoUrl_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_videoUrl(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyEditV2WebApiHandler_webSite_Args {
  postData: UserPropertyEditWebSiteV2RequestDto;
}

export type RentalManagerUserPropertyEditV2WebApiHandler_webSite_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditV2WebApiHandler_webSite_Args
>;

export const useRentalManagerUserPropertyEditV2WebApiHandler_webSite = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditV2WebApiHandler_webSite_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditV2WebApiHandler_webSite_Args) =>
      RentalManagerUserPropertyEditV2WebApiHandler_webSite(args.postData, httpClient),
  });
};
